import styled from 'styled-components';
import { MAIN_BLUE } from '../../styles/Colors';

export const ProductsContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
`;

export const ImageDecoration = styled.img`
  position: absolute;
  height: 100%;
  left: ${(props) => props.left && '0px'};
  right: ${(props) => props.right && '0px'};
  resize: vertical;
`;
export const CardsContainer = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  font-size: 3em;
  margin: 0;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
`;
export const CarouselContainer = styled.div`
  margin: 0 auto;
  height: auto;
  display: flex;
  width: 90%;
`;

export const ArrowButton = styled.div`
  position: relative;
  font-size: 0;
  line-height: 0;
  width: 32px;
  cursor: pointer;
  color: transparent;
  border: none;
  &::before {
    content: '${(props) => props.arrow && props.arrow}';
    margin: ${(props) => props.type === 'prev' ? '0 10px 0 0' : '0 0 0 10px'};
    position: relative;
    top: calc(50% - 20px);
    font-size: 80px;
    color: ${MAIN_BLUE};
    width: 32px;
    height: auto;
    border-radius: 4px;
    text-align: center;
  }
`;
